module.exports = __webpack_public_path__ + "static/media/form-logo.8bcef56f.svg";